module.exports = __webpack_public_path__ + "img/捐献流程图.1d9bb7ed.png";